import { render, staticRenderFns } from "./AppLogin.vue?vue&type=template&id=31a974fa&scoped=true&"
import script from "./AppLogin.vue?vue&type=script&lang=js&"
export * from "./AppLogin.vue?vue&type=script&lang=js&"
import style0 from "./AppLogin.vue?vue&type=style&index=0&id=31a974fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a974fa",
  null
  
)

export default component.exports